module.exports = __webpack_public_path__ + "media/images/front/responsive/institution-detail-rich/equipment02-6d8fa9ee90f0a0677fbccefbf463d2fa.png";